import styled from 'styled-components';
import { bouTextFont } from '../../../../../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../../../../../generic/global/bou-colors';
import { seriesColorScale } from '../../../../../../../../generic/global/colors';
import {
  useImpactChartContext,
  useImpactChartFontSizes,
  useImpactChartHeights,
  useImpactChartWidths,
} from '../../../context';
import { plusIfPositive } from '../../../shared';
import { formatImpactScore } from '../../../value-formatter';
import { DimensionRowProps } from '../types';

const DimensionScoreText = styled.text`
  ${bouTextFont};
  fill: ${BouColor.BLACK};
  font-weight: bold;
  text-anchor: middle;
`;

export function MultiseriesMiddlePart(props: DimensionRowProps) {
  const { data, desktopMode, formatters, scoreType, scoreReaders } = useImpactChartContext();
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const { dimensionTitles: fontSize } = useImpactChartFontSizes();

  const main = data.map((d, index) => {
    const scoreReader = scoreReaders[index];
    const total = scoreReader.readScore(undefined, props.dimension, undefined, undefined);
    const x = desktopMode
      ? widths.title + widths.bars + widths.middle / 2
      : widths.title + widths.bars + widths.middle - 16;
    const y =
      heights.dimensionRowMargin +
      (heights.dimensionRowBarHeight + heights.dimensionRowSeriesSpacing) * index +
      heights.dimensionRowBarHeight / 2;

    const color = d.color || seriesColorScale(index);
    const textAnchor = desktopMode ? 'middle' : 'end';
    const textX = desktopMode ? 0 : -20;
    if (total === undefined) {
      return <g key={index} />;
    }
    return (
      <Main key={index} transform={`translate(${x}, ${y})`}>
        <DimensionScoreText dy="0.35em" x={textX} style={{ textAnchor, fontSize }}>
          {plusIfPositive(total)}
          {formatImpactScore(total, formatters, scoreType)}
        </DimensionScoreText>
        {!desktopMode && <rect width={10} height={10} x={textX + 10} y={-10 / 2} fill={color} />}
      </Main>
    );
  });
  return <g>{main}</g>;
}

const Main = styled.g`
  transition: transform 0.12s ease-in-out;
`;
